import HttpClient from './types';
function isHttpClient(client) {
    // This check is by no means complete, but it will validate the basics!
    return client && !['delete', 'get', 'head', 'options', 'post', 'put', 'patch']
        .filter((method) => {
        if (!Object.prototype.hasOwnProperty.call(client, method)) {
            return true;
        }
        const pd = Object.getOwnPropertyDescriptor(client, method);
        return !pd || typeof pd.value !== 'function';
    })
        .length;
}
export { isHttpClient, };
//# sourceMappingURL=httpclient.js.map